/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Manual/WIFEndpointFooterComponent" />
import React = require("react");
import { VssComponent } from "VSS/Platform/Layout";
import { WIFFooterLinks } from "../Common/WIFFooterLinks";
import { EndpointFooterComponent, IEndpointFooterComponentProps } from "../Common/EndpointFooterComponent";

export class WIFEndpointFooterComponent extends VssComponent<IEndpointFooterComponentProps> {

    public render(): JSX.Element {
        return (<EndpointFooterComponent
                renderButtons={this.props.renderButtons}
                renderLinks={() => <WIFFooterLinks />}
            />);
    }
}


